import mixitup from 'mixitup';

export default class SearchFilter {
	constructor($searchfilter) {

		this.filterContainer = $searchfilter;
		this.cardsContainer = document.querySelector('[data-card-container]');
		this.checkedInputs = null;

		this.cardSelector = '[data-card]';
		this.originalCollection = this.cardsContainer.querySelectorAll(this.cardSelector);
		this.resetBtns = document.querySelectorAll('[data-reset-filter]');

        this.counter = document.querySelector('[data-counter]');

		this.resetBtns.forEach((btn) => {
			btn.addEventListener('click', this.resetFilters.bind(this));
		});

		this.filterContainer.addEventListener('change', this.filter.bind(this));

		this.mixer = mixitup(this.cardsContainer, {
			selectors: {
				target: this.cardSelector,
			},
			animation: {
				duration: 400,
				queueLimit: 5,
				effects: 'fade translateY(100px)',
			},
		});

		this.filter(true);
	}

	resetFilters() {
		this.checkedInputs.forEach((checkedInput) => {
			checkedInput.checked = false;
		});

		const event = new Event('change');
		this.filterContainer.dispatchEvent(event)
	}

	filter() {
		this.checkedInputs = this.filterContainer.querySelectorAll(':checked');

		let selector = this.cardSelector;

		// custom selector based on checked inputs
		if (this.checkedInputs.length) {
			selector = '';

			this.checkedInputs.forEach(input => {
                if (selector.length <= 0) {
                    selector = `.${input.value}`;
                } else {
                    selector = `${selector}, .${input.value}`;
                }
			});
		}

		// collection cards with the default selector or based on custom selector
		this.collectionCards = this.cardsContainer.querySelectorAll(selector);


		this.mixer.filter(this.collectionCards);

		let itemCount = this.collectionCards.length;
		if(this.counter) {
			this.counter.innerHTML = itemCount;
			this.failMessage = document.querySelector('[data-fail-message]');
			if (itemCount <= 0) {
				this.failMessage.style.display = 'block';
			} else {
				this.failMessage.style.display = 'none';
			}
		}

	}
}
